export default __webpack_public_path__ + "static/media/betslipEmpty.480dbd2d.png";